<section class="login-page">
  <div class="sp-container">
    <div class="sp-row">
      <div [ngClass]="[mobilePhoto ? 'sp-col sp-col--5 sp-col-sm--12' : 'sp-col sp-col--12 sp-col-sm--12']">
        <form [formGroup]="loginForm" novalidate *ngIf="!showConfirmCode">
          <h1 class="pt-5 pb-5">دخول أو تسجيل جديد</h1>
          <div class="form-group">
            <!-- <label>رقم الجوال</label> -->
            <div class="phone_number clearfix">
              <div class="input-login input-for-phone">
                <sp-input
                  class="ltrNumber force-ltr"
                  type="text"
                  (keypress)="keyPress($event); checkValidation($event)"
                  (keydown)="handleEnterKey($event)"
                  pattern="[0-9]*"
                  name="number"
                  id="number"
                  formControlName="number"
                  [required]="true"
                  maxlength="{{ firstDigit === '0' ? 10 : 9 }}"
                  [label]="'5XXXXXXXXX'"
                  [style]="'inside conain-context'"
                ></sp-input>
              </div>
            </div>
            <div class="validation-messages">
              <p class="error" *ngIf="loginForm.get('number') && loginForm.get('number').value && !valid">
                هذا الرقم غير صالح , يجب ان يبدا برقم 5 او 05
              </p>
              <p class="error" *ngIf="!loginForm.get('number').value && loginForm.get('number').touched">من فضلك ادخل رقم الجوال</p>
            </div>
          </div>
          <div class="form-group responsive_button mt-5 float-left confirm-phone" [ngClass]="[showBackStepButton ? 'two-btns' : '']">
            <sp-button
              *ngIf="showBackStepButton"
              [label]="'القطع المطلوبة'"
              [size]="'large'"
              [style]="'secondary'"
              class="full-width button-arrow-right"
              (clickAction)="handleBackStep($event)"
              icon="navigation-right-3"
            >
            </sp-button>
            <sp-button
              [disabled]="!loginForm.valid || !validMobile"
              [label]="'تاكيد رقم الجوال'"
              (clickAction)="getOTPValidator($event)"
              [style]="loginForm.valid && validMobile ? 'primary' : 'secondary'"
            ></sp-button>
          </div>
        </form>
        <div class="options-widget" *ngIf="showConfirmCode">
          <div class="sp-container">
            <h4 class="modal-title">أرسلنا رقم التاكيد على جوالك</h4>
            <div class="mob-num" *ngIf="num">
              {{ num }}
              <span class="edit-num" (click)="goBacktoEditNum()">(تعديل رقم الجوال)</span>
            </div>
            <div *ngIf="result">
              <div *ngIf="result.case === 1 || result.case === 2 || result.case === 4">
                <form [formGroup]="confirmForm" novalidate>
                  <div class="form-group text-center m-3 code">
                    <p *ngIf="mobileNum">{{ mobileNum.mobile }}</p>
                    <div class="otp-fields-group">
                      <div>
                        <input
                          [getFocus]="true"
                          type="tel"
                          maxlength="4"
                          pattern="[0-9]*"
                          class="form-control"
                          formControlName="otp"
                          (keydown)="onlyNumberKey($event)"
                          (keyup)="sendActivationCode($event)"
                        />
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div class="alert alert-success" *ngIf="codeSent && codeValidate && codeValidate.case === 1">
                <span>
                  الكود مدخل صحيح، سيتم اعادة توجيهك الى صفحة الطلبات خلال ثواني، او
                  <a href="{{ appURL }}/customers/home/requests"> اضغط هنا للانتقال الى الصفحة الرئيسية</a>
                </span>
              </div>
              <div class="alert alert-danger" *ngIf="notValidMobileNumber">
                <span>
                  رقم الجوال المدخل غير صحيح، يرجى ادخال الرقم كالتالي :
                  <span>5XXXXXXXX</span>
                </span>
              </div>
              <div class="alert alert-info" *ngIf="(result.case === 1 || result.case === 2) && !codeValidate && remainSec > 0">
                <span>
                  يرجى ادخال رمز التحقق المرسل على جوالك &nbsp;
                  <span dir="ltr" class="countdown">{{ countDown | async | formatTime }}</span>
                </span>
              </div>
              <div class="resend-code" *ngIf="!codeValidate && remainSec === 0">
                <a (click)="get_otp($event)"> <img src="/public/resources/images/resend.png" /> &nbsp; اعادة ارسال الرمز </a>
              </div>
              <div class="alert alert-danger" *ngIf="result.case === 3 && !codeSent"><span>لا يمكن طلب كود لهذا الرقم</span></div>
              <div class="alert alert-danger" *ngIf="result.case === 4 && !codeSent && remainSec > 0">
                <span
                  >لا يمكن طلب كود جديد , حتى ينتهي الكود الحالي &nbsp;
                  <span dir="ltr" class="countdown">{{ countDown | async | formatTime }}</span>
                </span>
              </div>
              <div *ngIf="codeValidate && codeValidate.case === 2 && codeSent">
                <div class="alert alert-danger" *ngIf="remainSec">
                  <span>الكود المدخل غير صحيح</span>
                </div>
                <div class="resend-code" *ngIf="!remainSec">
                  <a (click)="get_otp($event)"> <img src="/public/resources/images/resend.png" /> &nbsp; اعادة ارسال الرمز </a>
                </div>
              </div>
              <div class="alert alert-danger" *ngIf="codeValidate && codeValidate.case === 3 && codeSent">
                <span>لقد حاولت اكثر من 5 محاولات! قم بطلب كود جديد</span>
              </div>
              <div class="alert alert-danger" *ngIf="codeValidate && codeValidate.case === 4 && codeSent">
                <span>لقد انتهي وقت الكود , يمكنك طلب كود جديد</span>
              </div>
              <div class="resend-code" *ngIf="codeValidate && (codeValidate.case === 4 || codeValidate.case === 3) && codeSent">
                <a (click)="get_otp($event)"> <img src="/public/resources/images/resend.png" /> &nbsp; اعادة ارسال الرمز </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="mobilePhoto" class="sp-col sp-col--7 sp-col-sm--12 hide-in-responsive img-login">
        <img src="/public/resources/images/mobile.svg" />
      </div>
    </div>
  </div>
</section>
